import { useTranslation } from "react-i18next";
import { useCookieContext } from "../../context/CookieContext";
import styles from "./CookiePopupButton.module.scss";

const CookiePopupButton = () => {
  const { t } = useTranslation("common");
  const { openBanner } = useCookieContext();

  return (
    <button
      onClick={openBanner}
      className={styles.popupButton}
      aria-label={t("cookies.openSettings")}
    >
      <img src="/images/cookie.svg" alt="" aria-hidden="true" />
    </button>
  );
};

export default CookiePopupButton;
